import Api from "../api";
let uri = '/api/ed/producto';

export const getProductos = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminProductos = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}



